import _extends from "@babel/runtime/helpers/extends";
import { ReporterInterface } from './ReporterInterface';
import isNode from '../../../helpers/isNode';
import axios from 'axios';
export class GelfServiceReporter extends ReporterInterface {
  static create(_ref) {
    let {
      service,
      requestID
    } = _ref;

    if (!service) {
      throw new Error("[GelfServiceReporter.create] service(" + service + ") is mandatory");
    }

    return new GelfServiceReporter({
      service,
      requestID
    });
  }

  constructor(_ref2) {
    let {
      service,
      requestID
    } = _ref2;
    super();
    this._messages = [];
    this._sending = false;
    this._service = service;
    this._requestID = requestID;

    this._addEvents();

    this._sendPrevMessages();
  }

  send(_ref3) {
    let {
      metricName = 'NO_METRIC_NAME_SET',
      status,
      value,
      errorMSG
    } = _ref3;

    this._messages.push(_extends({
      _metric: metricName,
      _status: status,
      _time: value,
      _origin: isNode ? GelfServiceReporter.SERVER : GelfServiceReporter.BROWSER,
      _createdAt: Date.now(),
      _app: GelfServiceReporter.APP
    }, errorMSG && {
      _error: errorMSG
    }, this._requestID && {
      _request_id: this._requestID
    }));

    if (this._messages.length > GelfServiceReporter.QUEUE_LENGTH) {
      this._sendToService();
    }
  }

  _sendToService() {
    try {
      if (this._sending) return false;
      if (!this._messages || this._messages.length === 0) return false;
      this._sending = true;
      axios.post(this._service + '/send', this._messages.splice(0, GelfServiceReporter.QUEUE_LENGTH)).finally(() => {
        this._sending = false;
      });
    } catch (err) {
      this._sending = false;
      this._messages = [];
    }
  }

  _storageUnsendMessages() {
    try {
      window.localStorage.setItem(GelfServiceReporter.STORAGE_KEY, JSON.stringify(this._messages));
    } catch (err) {
      console.error(err);
    }
  }

  _addEvents() {
    if (isNode) return false;

    if (window.onpagehide) {
      addEventListener('pagehide', this._sendToService, {
        capture: true
      });
    } else {
      // addEventListener('unload', this._storageUnsendMessages.bind(this), { capture: true })
      addEventListener('beforeunload', this._storageUnsendMessages.bind(this), {
        capture: true
      });
    }

    addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        this._sendToService();
      }
    }, {
      capture: true
    });
  }

  _sendPrevMessages() {
    if (isNode) return false;

    try {
      const messagesJSON = window.localStorage.getItem(GelfServiceReporter.STORAGE_KEY);
      const prevMessages = JSON.parse(messagesJSON);
      window.localStorage.removeItem(GelfServiceReporter.STORAGE_KEY);
      if (!prevMessages || prevMessages.length === 0) return false;
      this._messages = prevMessages;

      this._sendToService();
    } catch (err) {
      console.error(err);
    }
  }

}
GelfServiceReporter.SERVER = 'server';
GelfServiceReporter.BROWSER = 'browser';
GelfServiceReporter.APP = 'frontend';
GelfServiceReporter.QUEUE_LENGTH = 10;
GelfServiceReporter.STORAGE_KEY = '__GELF_SERVICE_REPORTER_MESSAGES__';